export default "__VITE_ASSET__BqV1fjo9__"